{
  "menu": {
    "dashboard": "Dashboard",
    "presence": "Aanwezigheidslijst",
    "bookings": "Boekingen",
    "workplaces": "Werkplekken",
    "lunches": "Lunches",
    "transport": "Parkeerplekken",
    "statistics": "Statistieken",
    "reports": "Rapportages",
    "teams": "Teams",
    "buildings": "Gebouwen",
    "settings": "Systeeminstellingen",
    "advanced": "Geavanceerd",
    "timeslots": "Tijdsloten",
    "timeslot_kinds": "Tijdslot soorten",
    "timeslot_groups": "Tijdslot groepen",
    "qrcodes": "Scan QR-codes",
    "meeting_rooms": "Vergaderruimtes",
    "companies": "Bedrijven",
    "jobtitles": "Functies",
    "information_messages": "Bericht",
    "company": "Bedrijf",
    "ero": "Bedrijfshulpverleners",
    "confidant": "Vertrouwenspersonen",
    "bookings_validate": "Boekingen goedkeuren",
    "emails": "Automatische e-mails",
    "app_messages": "In app berichten",
    "credits": "Credits"
  },
  "pages": {
    "dashboard": {
      "titles": {
        "statistics": "Aanwezigheid voor {{name}}",
        "meeting_rooms": "Vergaderruimtes in {{name}}"
      },
      "building": {
        "show_all_present": "[ Bekijk alle aanwezige medewerkers ]"
      },
      "meeting_rooms": {
        "title": "{{name}} ",
        "title_capacity": "[capaciteit {{capacity}} personen]",
        "show_all_timeslots": "[ Toon alle tijdsloten ]",
        "hide_all_timeslots": "[ Toon enkel huidige tijdsloten ]",
        "timeslots": {
          "loading": "Bezig met laden",
          "booked": "{{employee_count}} personen; geboekt door {{name}}",
          "available": "Beschikbaar"
        }
      }
    },
    "bookings": {
      "index": {
        "booking": {
          "title": "Werkplekken"
        },
        "lunch": {
          "title": "Boekingen - Lunches"
        },
        "transport": {
          "title": "Boekingen - Vervoer"
        },
        "meeting_room": {
          "title": "Boekingen - Vergaderruimtes"
        }
      },
      "view": {
        "workplaces": {
          "title": "Werkplekken - {{name}}"
        },
        "lunch": {
          "title": "Lunches - {{name}}"
        },
        "transport": {
          "title": "Vervoer - {{name}}"
        },
        "booking": {
          "title": "Boekingen - Werkplekken - {{name}}"
        },
        "remove": {
          "title": "Weet je zeker dat je deze boeking wilt verwijderen?",
          "button": "Verwijder deze boeking",
          "reason": "Reden van verwijdering",
          "description": "Geef aan welke tijdsloten je wilt verwijderen voor deze medewerker."
        },
        "meeting_room": {
          "title": "Vergaderruimte - {{name}}"
        },
        "toggle_only_show_not_scanned_in": "Toon alleen niet ingescand",
        "search_employee": "Zoek op medewerker",
        "toggle_only_show_invitations": "Toon alleen uitnodigingen",
        "statistic": {
          "booking_count": "Totaal aantal boekingen: {{amount}}",
          "employee_count": "Totaal aantal collega's: {{amount}}"
        },
        "bookings_validate": {
          "approve": {
            "button": "Keur voertuig goed"
          },
          "disapprove": {
            "button": "Keur voertuig af"
          },
          "information": "Bij het reserveren van een parkeerplaats met beperkingen kan het voorkomen dat we niet alle informatie over een voertuig kunnen achterhalen. Hierdoor kunnen we niet met zekerheid vaststellen of een auto hier mag parkeren. Geef daarom handmatig aan of deze auto's hier mogen parkeren."
        }
      }
    },
    "presence": {
      "index": {
        "title": "Aanwezigheidslijst",
        "input_search": "Zoek naar medewerker"
      },
      "building_presence": "{{amount}} van de {{amount2}} medewerkers zijn aanwezig ({{percentage}}%)",
      "building_booking": "{{amount}} boekingen vandaag",
      "building_response_employee": "{{amount}} van de {{amount2}} BHV'ers zijn aanwezig ({{percentage}}%)",
      "building_select": "Selecteer de gebouwen"
    },
    "occupancy": {
      "building_select": "Selecteer gebouw/verdieping/kamer",
      "timeslot_kind_select": "Selecteer tijdslot soort"
    },
    "qrcodes": {
      "index": {
        "title": "Scan QR-codes",
        "download_pdf_title": "PDF bestand",
        "download_pdf_description": "Na het drukken op de knop zal er een PDF bestand worden gemaakt aan de hand van de geselecteerde locatie hierboven.",
        "download_pdf_button": "Maak het PDF bestand",
        "warning_inactive": "Let op! Deze QR-code werkt niet. Mogelijk dat het gebouw waar deze QR-code voor is gemaakt op inactief staat.",
        "warning": "QR-code is inactief"
      }
    },
    "settings": {
      "index": {
        "title": "Systeeminstellingen",
        "reload_takes_time": "De applicatie instellingen zijn opnieuw geladen, het kan tot 5 minuten duren voor andere apparaten deze ontvangen"
      }
    },
    "statistics": {
      "index": {
        "title": "Statistieken",
        "btn_details": "Details"
      }
    },
    "buildings": {
      "buildings": {
        "title": "Gebouwen",
        "input_search": "Zoek gebouw"
      },
      "building": {
        "title": "Gebouw  - {{name}}",
        "input_search": "Zoek verdieping",
        "employee": {
          "input_search": "Zoek medewerker"
        },
        "team": {
          "input_search": "Zoek verdieping"
        }
      },
      "floor": {
        "title": "Verdieping  - {{name}}",
        "input_search": "Zoek kamer"
      },
      "room": {
        "title": "Kamer  - {{name}}"
      },
      "contact": {
        "input_search": "Zoek contactpersoon",
        "title": "Contactpersoon"
      },
      "timeslot_exceptions": {
        "title": "Tijdslot uitzonderingen",
        "kind": "Soort uitzondering",
        "name": "Reden van uitzondering (alleen zichtbaar in beheer)",
        "timeslots": "Tijdsloten",
        "reduce_by": "Verminder capaciteit met",
        "date_start_end": "Datum van/tot",
        "comment": "Opmerking in app (niet verplicht)",
        "kinds": {
          "block": "Blokkeer",
          "unblock": "Deblokkeer",
          "reduce": "Verminder capaciteit",
          "increase": "Verhoog capaciteit",
          "hidden": "Verborgen"
        },
        "increase_by": "Verhoog capaciteit met"
      }
    },
    "teams": {
      "teams": {
        "title": "Teams",
        "input_search_team": "Zoek team",
        "input_search_employee": "Zoek collega",
        "subtitle": "Aantal collega's: {{count}}"
      },
      "team": {
        "title": "Team",
        "input_search": "Zoek medewerker"
      },
      "employee": {
        "title": "Medewerker",
        "block_admin": {
          "title": "Beheerder",
          "description": "Door middel van onderstaande knop is het mogelijk de mederwerker beheerder functionaliteit toe te kennen of af te nemen.",
          "button_create": "Maak medewerker een beheerder",
          "button_delete": "Verwijder beheerder functies",
          "button_save_rights": "Rechten opslaan",
          "button_rights": "Rechten beheren"
        },
        "block_account": {
          "title": "Account",
          "description": "Door op onderstaande knop te drukken zal het account worden verwijderd en is er geen mogelijkheid meer om dit account te herstellen.",
          "button_delete": "Verwijder account"
        }
      }
    },
    "reports": {
      "index": {
        "title": "Rapportages",
        "btn_download": "Download"
      },
      "download": {
        "title": "Download"
      },
      "schedule": {
        "title": "Automatisch"
      }
    },
    "company": {
      "companies": {
        "title": "Bedrijven",
        "subtitle": "Aantal afdelingen: {{count}}",
        "input_search_company": "Zoek bedrijf"
      },
      "company": {
        "title": "Bedrijf",
        "input_search": "Zoek naar afdeling"
      },
      "department": {
        "title": "Afdeling"
      }
    },
    "jobtitles": {
      "jobtitle": {
        "title": "Functie"
      },
      "jobtitles": {
        "title": "Functies",
        "input_search": "Zoek naar functie"
      }
    },
    "information_messages": {
      "index": {
        "title": "Bericht",
        "ubb_explanation": "Je kan BB-code gebruiken om simpele opmaak toe te voegen aan je bericht\n\n[header]Dit is een header[/header]\n[b]Deze tekst is dik gedrukt[/b]\n[i]Deze tekst is schuin gedrukt[/i]\n[u]Deze tekst is onderstreept[/u]"
      }
    },
    "employee": {
      "advanced": {
        "title": "Geavanceerd"
      },
      "credits": {
        "button_add_remove": "Aantallen beheren"
      }
    },
    "timeslots": {
      "title": "Tijdsloten",
      "timeslotGroups": {
        "title": "Tijdslotgroepen",
        "input_search": "Zoek tijdslotgroep"
      },
      "timeslotKinds": {
        "title": "Tijdslotsoorten",
        "input_search": "Zoek tijdslotsoort"
      }
    },
    "emails": {
      "index": {
        "title": "Automatsiche e-mails",
        "input_search": "Zoeken"
      },
      "edit": {
        "title": "Bewerken"
      }
    },
    "app_messages": {
      "index": {
        "title": "In app berichten"
      },
      "edit": {
        "title": "Bewerken"
      }
    },
    "credits": {
      "title": "Credits",
      "generate_file": "Maak de QR-code",
      "generate_text": "Klik op de knop om het QR-codebestand te genereren, dat kan worden gescand om de betaling te starten.\nNa de betaling verschijnt op het scherm van de koper een duim omhoog of een duim omlaag, wat aangeeft of de betaling is geslaagd of niet.\nDaarnaast wordt ook de datum weergegeven waarop de betaling is gestart, ter verificatie."
    }
  },
  "generic": {
    "load_error": "De gegevens konden niet worden geladen. Probeer het opnieuw.",
    "retry": "Opnieuw proberen",
    "view_all_from": "Bekijk alles van {{name}}",
    "add": "Toevoegen",
    "no_results": "Geen resultaat",
    "booking": {
      "kind": {
        "booking": "Werkplek",
        "lunch": "Lunch",
        "transport": "Vervoer",
        "meeting_room": "Vergaderruimte"
      },
      "status": {
        "invite_accepted": "Uitnodiging geaccepteerd",
        "invite_rejected": "Uitnodiging geweigerd",
        "cancelled": "Geannuleerd",
        "invited": "Uitgenodigd",
        "active": "Actief"
      }
    },
    "active": {
      "yes": "Active",
      "no": "Inactive"
    },
    "building": {
      "kind": {
        "office": "Kantoor",
        "parkinglot": "Parkeerplaats"
      }
    },
    "timeslot": {
      "kind": {
        "booking": "Werkplek",
        "lunch": "Lunch",
        "meeting_room": "Vergaderruimte",
        "transport": "Parkeerplaats"
      },
      "add": "Voeg tijdslot toe",
      "remove": {
        "title": "Weet je het zeker dat je het tijdslot wilt verwijderen?",
        "button": "Ja, ik wil het tijdslot verwijderen."
      },
      "description_accepted_some": "De volgende tijden zijn geaccepteerd: {{timeslots}}"
    },
    "remove": "Verwijder",
    "drag": "Wijzig volgorde",
    "employee": {
      "kind": {
        "external": "Externe gast",
        "internal": "Mederwerker"
      }
    },
    "scan": {
      "scanned_in_at": {
        "unkown": "Ingescand op: {{time}}",
        "qrcode": "Ingescanned met QR-code op: {{time}}",
        "button": "Ingescanned met knop op: {{time}}",
        "cronjob": "Automatisch ingescanned op: {{time}}",
        "automatic": "Automatisch ingescanned op: {{time}}",
        "qrcode_by_employee": "Ingescanned met QR-code door medewerker op: {{time}}"
      },
      "not_scanned_in": "Nog niet ingescand"
    },
    "parking_scan": {
      "not_scanned_in": "Nog niet ingescand",
      "scanned_in": "Ingereden op {{time}} met kenteken {{identifier}}",
      "scanned_out": "Uitgereden op {{time}} met kenteken {{identifier}}"
    },
    "booking_status": {
      "invite_open": "Uitnodiging (nog) niet geaccepteerd"
    },
    "invited_by": "Uitgenodigd door: {{name}}",
    "overview": "Overzicht",
    "from_to": "van {{from}} tot {{till}}",
    "occupied": "Bezet",
    "available": "Beschikbaar",
    "beta": "Dit onderdeel zit nog in beta en kan fouten bevatten",
    "today": "Vandaag",
    "activate": "Activeer",
    "deactivate": "Deactiveer",
    "created_at": "Gemaakt op"
  },
  "constants": {
    "scanin": "In en uitchecken",
    "book": "Boeken van een locatie"
  },
  "form": {
    "titles": {
      "personal": "Persoonlijk",
      "privacy": "Privacy",
      "company": "Bedrijf",
      "app_rights": "App rechten",
      "commute": "Woon-werkverkeer"
    },
    "kind": {
      "title": "Soort"
    },
    "name": {
      "title": "Naam",
      "system_name": "Systeemnaam",
      "en-gb": "Naam (Engels)",
      "nl-nl": "Naam (Nederlands)"
    },
    "save": "Opslaan",
    "saved": "Opgeslagen",
    "day": {
      "title": "Dag"
    },
    "credit_amount": {
      "title": "Aantal credits"
    },
    "timeslot_start": {
      "title": "Tijdslot begin"
    },
    "timeslot_end": {
      "title": "Tijdslot eind"
    },
    "show_time": {
      "title": "Toon tijd"
    },
    "show_capacity": {
      "title": "Toon capaciteit tijdens het kiezen van de locatie"
    },
    "show_capacity_in_timeslot": {
      "title": "Toon capaciteit tijdens het kiezen van een tijdslot"
    },
    "instructions_link": {
      "title": "Instructie link"
    },
    "capacity": {
      "title": "Capaciteit"
    },
    "can_only_select_one_per_day": {
      "title": "Kan slechts 1x per dag worden geboekt"
    },
    "can_overlap_with_booking": {
      "title": "Mag overlappen met een werkplekboeking op dezelfde tijd"
    },
    "can_book_for_self": {
      "title": "Kan geboekt worden door ingelogde medewerker"
    },
    "can_book_for_coworkers": {
      "title": "Kan geboekt worden voor collega's"
    },
    "can_book_for_external": {
      "title": "Kan geboekt worden voor externen"
    },
    "can_only_book_single_timeslot_per_day": {
      "title": "Kan slechts 1 boeking per dag doen"
    },
    "can_book_from": {
      "title": "Kan geboekt worden vanaf"
    },
    "can_book_until": {
      "title": "Kan geboekt worden t/m"
    },
    "can_cancel_until": {
      "title": "Kan geannuleerd worden t/m"
    },
    "count": {
      "title": "Aantal 'indicator' (10 werkplekken)"
    },
    "active": {
      "title": "Actief"
    },
    "timeslot_group": {
      "title": "Tijdslotgroep",
      "all": "Alle tijdslotgroepen"
    },
    "preview_timeslots": {
      "title": "Toon eerst beschikbaarheid voor het boeken"
    },
    "icon": {
      "title": "Icoon"
    },
    "sub_icon": {
      "title": "Sub-icoon"
    },
    "icon_color": {
      "title": "Icoon kleur"
    },
    "background_color": {
      "title": "Achtergrondkleur"
    },
    "available_for": {
      "short": "Beschikbaar voor",
      "title": "Beschikbaar voor teams",
      "description": "Selecteer voor welke teams dit item beschikbaar moet blijven."
    },
    "available_for_employees": {
      "title": "Beschikbaar voor medewerkers",
      "description": "Selecteer voor welke medewerkers dit item beschikbaar moet blijven."
    },
    "landline_phonenumber": {
      "title": "Vast telefoonnummer"
    },
    "response_employee": {
      "title": "Bedrijfshulpverlener"
    },
    "confidant": {
      "title": "Vertrouwenspersoon"
    },
    "teams": {
      "title": "Team"
    },
    "email": {
      "title": "Emailadres"
    },
    "days": {
      "title": "Dagen"
    },
    "time_start": {
      "title": "Begintijd"
    },
    "time_end": {
      "title": "Eindtijd"
    },
    "scan_option": {
      "title": "Scan optie"
    },
    "building": {
      "title": "Gebouw",
      "choose": "Kies een gebouw"
    },
    "floor": {
      "title": "Verdieping",
      "all": "Alle verdiepingen"
    },
    "room": {
      "title": "Kamer",
      "all": "Alle kamers"
    },
    "timeslot_kinds": {
      "title": "Tijdslotsoorten",
      "all": "Alle tijdslotsoorten",
      "hint": "Als je geen tijdslotsoorten kiest worden alle tijdslotsoorten boekbaar."
    },
    "jobtitles": {
      "title": "Functie"
    },
    "settings": {
      "titles": {
        "basics": "Basisinformatie",
        "bookings": "Boeken",
        "coworkers": "Collega's scherm",
        "coworkers_search": "Zoekscherm",
        "others": "Overig",
        "profile": "Profiel",
        "Information": "Informatie pagina",
        "information": "Informatie pagina",
        "privacy": "Privacy",
        "workday": "Werkdagen",
        "ero": "Bedrijfshulpverlener",
        "confidant": "Vertrouwenspersonen",
        "teams": "Teams",
        "presence": "Aanwezigheid",
        "commute": "Woon-werkverkeer",
        "credits": "Credits"
      },
      "company_name": {
        "title": "Bedrijfsnaam"
      },
      "email_tld": {
        "title": "E-mailadres domeinnaam"
      },
      "calendar_max_date": {
        "title": "Boekingen kunnen gemaakt worden tot en met",
        "options": {
          "week_1": "Tot 1 week vooruit",
          "week_2": "Tot 2 weken vooruit",
          "month_1": "Tot 1 maand vooruit",
          "month_2": "Tot 2 maanden vooruit",
          "month_3": "Tot 3 maanden vooruit",
          "month_4": "Tot 4 maanden vooruit",
          "month_5": "Tot 5 maanden vooruit",
          "month_6": "Tot 6 maanden vooruit"
        }
      },
      "booking_enable_parking": {
        "title": "Parkeerplaats boekingen"
      },
      "booking_enable_lunch": {
        "title": "Lunch boekingen"
      },
      "scan_in_enabled": {
        "title": "Inscannen ingeschakeld"
      },
      "scan_out_enabled": {
        "title": "Uitscannen ingeschakeld"
      },
      "transport_select_enabled": {
        "title": "Transportkeuze na inchecken"
      },
      "enable_coworkers_screen": {
        "title": "Collega's scherm actief"
      },
      "coworker_screen_shows": {
        "title": "Zichtbare collega's tijdens toevoegen"
      },
      "enable_coworkers_link_share": {
        "title": "Boekingen delen met collega's via link"
      },
      "enable_coworkers_direct_share": {
        "title": "Boekingen delen met collega's via QR-code"
      },
      "emergency_number": {
        "title": "Noodnummer bij BHV'er"
      },
      "booking_enable_reason": {
        "title": "Reden toevoegen bij boeken"
      },
      "scan_enable_presence_meter": {
        "title": "Drukte meter tonen"
      },
      "calendar_min_date": {
        "title": "Boekingen terugkijken tot"
      },
      "scan_enable_time": {
        "title": "Inscannen tijd tonen"
      },
      "coworker_search_company": {
        "title": "Zoek/Filter op bedrijf"
      },
      "coworker_search_team": {
        "title": "Zoek/Filter op team"
      },
      "coworker_search_department": {
        "title": "Zoek/Filter on afdeling"
      },
      "coworker_search_jobtitle": {
        "title": "Zoek/Filter on functie"
      },
      "coworker_calender_only_for_team": {
        "title": "Toon boekingen alleen voor medewerkers van hetzelfde"
      },
      "coworker_favourite_only_for_team": {
        "title": "Favorieten kunnen enkel worden toegevoegd binnen hetzelfde"
      },
      "coworker_phonenumber_only_for_team": {
        "title": "Toon telefoonnummer alleen voor ledmedewerkersen van hetzelfde"
      },
      "coworker_show_phonenumber": {
        "title": "Toon mobiel telefoonnummer in profiel"
      },
      "coworker_show_emailaddress": {
        "title": "Toon e-mailadres in profiel"
      },
      "coworker_show_landline_phonenumber": {
        "title": "Toon vast telefoonnummer in profiel"
      },
      "profile_enable_photo_editing": {
        "title": "Medewerker kan naam profielfoto"
      },
      "profile_enable_name_editing": {
        "title": "Medewerker kan naam bewerken"
      },
      "profile_enable_phonenumber_editing": {
        "title": "Medewerker kan mobiel telefoonnummer bewerken"
      },
      "profile_enable_landline_phonenumber_editing": {
        "title": "Medewerker kan vast telefoonnummer bewerken"
      },
      "profile_enable_jobtitle_editing": {
        "title": "Medewerker kan functie bewerken"
      },
      "profile_enable_team_editing": {
        "title": "Medewerker kan team bewerken"
      },
      "profile_enable_department_editing": {
        "title": "Medewerker kan afdeling bewerken"
      },
      "booking_enable_parking_license_plate": {
        "title": "Nummerplaatinvoer toevoegen"
      },
      "privacy_editing": {
        "title": "Bewerken van privacy toestaan"
      },
      "privacy_show_phonenumber": {
        "title": "Wie kan telefoonnummers zien"
      },
      "privacy_show_calendar": {
        "title": "Wie kan boekingen van collega's zien"
      },
      "privacy_show_favourite": {
        "title": "Wie kan favorieten toevoegen"
      },
      "privacy_show_landline_phonenumber": {
        "title": "Wie kan vaste telefoonnummers zien"
      },
      "privacy_visible_for_employees_default": {
        "title": "Zichtbaar voor collega's"
      },
      "profile_editing": {
        "title": "Sta profielbewerking toe"
      },
      "workday_editing": {
        "title": "Bewerken werkdagen toestaan"
      },
      "coworker_enable_search": {
        "title": "Zoekpagina voor collega's inschakelen"
      },
      "log_in_qr_code": {
        "title": "Inloggen met QR-code (alleen web)"
      },
      "ero_enable": {
        "title": "Bedrijfshulpverlener ingeschakeld"
      },
      "confidant_enable": {
        "title": "Vertrouwenspersoon ingeschakeld"
      },
      "profile_enable_ero_editing": {
        "title": "Bewerken van bedrijfshulpverlener optie toestaan"
      },
      "profile_access_card_id_editing": {
        "title": "Bewerken van toegangskaartnummer optie toestaan"
      },
      "enable_teams": {
        "title": "Teams inschakelen"
      },
      "scan_out_type": {
        "title": "Uitscannen optie"
      },
      "scan_in_type": {
        "title": "Inscannen optie"
      },
      "commute_enable": {
        "title": "Woon-werkverkeer bijhouden"
      },
      "credits_enabled": {
        "title": "Credit systeem actief"
      }
    },
    "description": {
      "title": "Beschrijving"
    },
    "aed": {
      "title": "AED aanwezig",
      "description": "Selecteer of er een AED beschikbaar is of niet"
    },
    "phonenumber": {
      "title": "Telefoonnummer"
    },
    "visible_for_employees": {
      "title": "Zichtbaar voor collega's"
    },
    "verified": {
      "title": "Geverifieerd"
    },
    "time_select": {
      "minute": "{{number}} minuut",
      "minute_other": "{{number}} minuten",
      "week": "{{number}} week",
      "week_other": "{{number}} weken",
      "month": "{{number}} maand",
      "month_other": "{{number}} maanden",
      "year": "{{number}} jaar",
      "year_other": "{{number}} jaar",
      "hour": "{{number}} uur",
      "hour_other": "{{number}} uren",
      "none": "Niet",
      "day": "{{number}} dag",
      "day_other": "{{number}} dagen",
      "always": "Altijd"
    },
    "no_limit": "Geen limiet",
    "time_before_start_time": {
      "week": "{{count}} week voor start tijd",
      "week_other": "{{count}} weken voor start tijd",
      "day": "{{count}} dag voor start tijd",
      "day_other": "{{count}} dagen voor start tijd",
      "hour": "{{count}} uur voor start tijd",
      "hour_other": "{{count}} uren voor start tijd",
      "minute": "{{count}} minuut voor start tijd",
      "minute_other": "{{count}} minuten voor start tijd",
      "at": "Tot begin van start tijd"
    },
    "time_after_start_time": {
      "hour": "{{count}} uur na start tijd (en voor eind tijd)",
      "hour_other": "{{count}} uren na start tijd (en voor eind tijd)",
      "minute": "{{count}} minuut na start tijd (en voor eind tijd)",
      "minute_other": "{{count}} minuten na start tijd (en voor eind tijd)"
    },
    "error": "Opslaan mislukt",
    "companies": {
      "title": "Bedrijf"
    },
    "departments": {
      "title": "Afdeling"
    },
    "title": {
      "title": "Titel"
    },
    "content": {
      "title": "Content"
    },
    "available_for_employee": {
      "description": "Selecteer welke medewerkers dit onderdeel mogen boeken.",
      "title": "Beschikbaar voor medewekers"
    },
    "search": {
      "title": "Zoeken"
    },
    "external_id": {
      "title": "Medewerkersnummer"
    },
    "can_scan_presence_qr_code": {
      "title": "Kan QR-code scannen voor aanwezigheid"
    },
    "can_scan_presence_qr_code_from": {
      "title": "Kan QR-code scannen voor aanwezigheid hoe lang voor start tijdslot"
    },
    "can_scan_presence_qr_code_until": {
      "title": "Kan QR-code scannen voor aanwezigheid hoe lang na start tijdslot"
    },
    "constants": {
      "book": "Boek locatie",
      "scanin": "In/uit scannen"
    },
    "timeslot_kind_available_for": {
      "team": "Teams",
      "employee": "Medewerkers",
      "jobtitle": "Functies"
    },
    "extra_parameters": {
      "title": "Extra parameters"
    },
    "time": {
      "title": "Tijd"
    },
    "for_date": {
      "title": "Voor welke dag"
    },
    "language": {
      "title": "Taal"
    },
    "lunch_options": {
      "title": "Lunch opties",
      "hint": "Selecteer de beschikbare lunch opties voor dit gebouw"
    },
    "limitation_car_type": {
      "title": "Soort voertuig",
      "motorcycle": "Motorfiets",
      "car": "Auto",
      "company_car": "Bedrijfswagen"
    },
    "limitation_car_fuel_type": {
      "title": "Voertuig brandstoftype",
      "electric": "Electrisch",
      "hybrid": "Hybride",
      "petrol": "Benzine",
      "diesel": "Diesel",
      "lpg": "LPG"
    },
    "car_length_max": {
      "title": "Maximale voertuig lengte"
    },
    "car_width_max": {
      "title": "Maximale voertuig breedte"
    },
    "car_height_max": {
      "title": "Maximale voertuig hoogte"
    },
    "car_wheelbase_max": {
      "title": "Maximale voertuig wielbasis"
    },
    "car_weight_max": {
      "title": "Maximale voertuig gewicht"
    },
    "type": {
      "title": "Soort",
      "booking_noshow": "Niet komen opdagen"
    },
    "subject": {
      "title": "Onderwerp"
    },
    "address_postal_code": {
      "title": "Adres",
      "description": "Het adres waar het gebouw staat"
    },
    "status": {
      "title": "Status",
      "active": "Actief",
      "inactive": "Inactief"
    },
    "price": {
      "title": "Prijs"
    }
  },
  "statistics": {
    "bookings_created_by_weekday": {
      "title": "App gebruik",
      "description": "Dagen waarop werkplekboekingen worden geplaatst"
    },
    "bookings_scheduled_by_weekday": {
      "title": "Werkplek bezetting",
      "description": "Meest populaire kantoordagen op basis van werkplek boekingen"
    },
    "bookings_created_by_day": {
      "description": "Dagen waarop werkboekingen zijn geplaatst",
      "title": "App-gebruik"
    },
    "bookings_created_by_month": {
      "description": "Maanden waarop werkboekingen zijn geplaatst",
      "title": "App-gebruik"
    },
    "bookings_scheduled_by_day": {
      "description": "Meest populaire kantoordagen op basis van werkplekboekingen",
      "title": "Werkplekbezetting"
    },
    "bookings_scheduled_by_month": {
      "description": "Meest populaire kantoormaanden op basis van werkplekboekingen",
      "title": "Werkplekbezetting"
    },
    "general": {
      "day": "Dag",
      "bookings": "Boekingen",
      "percentage": "Percentage",
      "year": "Jaar",
      "week": "Week",
      "name": "Naam",
      "amount": "Aantal",
      "time": "Tijd"
    }
  },
  "reports": {
    "bookings_on_day": {
      "title": "Werkplek boekingen per dag",
      "description": "Excelsheet met alle werkplek boekingen op de geselecteerde datum"
    },
    "lunches_on_day": {
      "title": "Lunch boekingen per dag",
      "description": "Excelsheet met alle Lunch boekingen en lunchkeuzes (indien van toepassing) op de geselecteerde datum"
    },
    "parking_on_day": {
      "title": "Parkeerplaats boekingen per dag",
      "description": "Excelsheet met alle parkeerplaats boekingen en in/uitrijd tijden (indien van toepassing) op de geselecteerde datum"
    },
    "employee_booking_count": {
      "title": "Werkplek boeking aantallen per medewerker",
      "description": "Excelsheet met het totaal aantal boekingen per medewerker op de geselecteerde datum"
    },
    "transports_on_day": {
      "title": "Vervoers boekingen per dag",
      "description": "Excelsheet met alle vervoers boekingen op de geselecteerde datum"
    },
    "workdays": {
      "title": "Werkdagen per medewerker",
      "description": "Excelsheet met alle werkdagen van medewerkers op kantoor of thuis op de geselecteerde datum"
    },
    "occupancy": {
      "title": "Bezettingsgraad per gebouw/verdieping/kamer en tijdslotsoort op de geselecteerde datum",
      "description": "Excelsheet met de bezettingsgraad per gebouw/verdieping/kamer en tijdslotsoort op de geselecteerde datum"
    },
    "commutes": {
      "title": "Woon-werkverkeer",
      "description": "Excelsheet met alle CO2 uitstoot van woon-werkverkeer bewegingen"
    },
    "credits": {
      "title": "Credits",
      "description": "Excelsheet met alle aankopen en het gebruik van credits per persoon, weergegeven op afzonderlijke tabbladen."
    }
  },
  "languages": {
    "nl-nl": "Nederlands",
    "en-gb": "Engels"
  },
  "form_block": {
    "title_default": "Gegevens",
    "title_timeslot": "Tijdslot",
    "title_timeslot_exceptions": "Tijdslot uitzonderingen",
    "title_timeslot_other": "Tijdsloten",
    "title_available_for_employees": "Medewerkers toegang",
    "title_available_for_teams": "Team toegang",
    "title_contact_persons": "Contactpersonen",
    "title_floor": "Verdieping",
    "title_floor_other": "Verdiepingen",
    "title_room": "Kamer",
    "title_room_other": "Kamers",
    "title_statistic": "Statistiek",
    "title_statistic_other": "Statistieken",
    "title_image": "Afbeelding",
    "title_icon": "Icoon",
    "title_advanced": "Geavanceerd",
    "title_exceptions": "Uitzonderingen",
    "title_lunch": "Lunch opties",
    "title_limitations": "Limitaties"
  },
  "modal": {
    "scan": {
      "title": "Medewerker inscannen",
      "description": "Wil je de medewerker inscannen voor vandaag? Dit is ook bedoeld om externe gasten in te scannen voor de aanwezigheid statistieken.",
      "button_confirm": "Scan in"
    },
    "basic": {
      "cancel": "Annuleren"
    },
    "status": {
      "title": "Boeking status wijzigen",
      "description": "De huidige status van de boeking is \"{{current_status}}\". Selecteer wat de nieuwe status moet worden van deze boeking.",
      "button_confirm": "Pas boeking aan"
    },
    "block_account": {
      "title": "Account verwijderen",
      "button_confirm": "Verwijderen",
      "description": "Na confirmatie zal het account worden verwijderd en is deze niet meer te herstellen."
    },
    "admin_rights": {
      "title": "Admin rechten"
    },
    "credit_management": {
      "text": "Bewerk het aantal credits voor dit type. Je kunt het aantal credits verhogen of verlagen.\nBij een verhoging is geen extra betaling nodig.\nLet op: alleen ongebruikte credits kunnen worden verwijderd."
    }
  },
  "charts": {
    "chart_checkin_time": {
      "title": "Check-in tijd",
      "description": "Op deze tijden wordt er het meeste ingecheckt"
    },
    "chart_book_time": {
      "title": "Boek tijd",
      "description": "Op deze tijden worden de meeste boekingen gemaakt"
    },
    "chart_employee_bookings_week": {
      "title": "Boekingen per week",
      "description": "Aantal medewerkers die meerdere dagen per week op kantoor komen"
    },
    "chart_bookings_created_by_weekday": {
      "title": "Boek dagen",
      "description": "De dagen waarop de meeste boekingen worden gemaakt"
    },
    "chart_bookings_scheduled_by_weekday": {
      "title": "Geboekte dagen",
      "description": "De dagen waarvoor de meeste boekingen worden gemaakt"
    },
    "tabs": {
      "office": "Kantoorbezoek",
      "usage": "App gebruik"
    },
    "chart_total_bookings_week": {
      "title": "Totaal aantal boekingen per week",
      "description": "Alle tijdslot boekingen bij elkaar geteld gescheiden op soort"
    },
    "chart_bookings_present": {
      "title": "Totaal aantal boekingen + aanwezigheid per jaar",
      "description": "De aantallen zijn gegroepeerd per medewerker per jaar"
    },
    "chart_bookings_present_week": {
      "title": "Totaal aantal boekingen + aanwezigheid per week",
      "description": "De aantallen zijn gegroepeerd per medewerker per week"
    },
    "chart_bookings_present_month": {
      "title": "Totaal aantal boekingen + aanwezigheid per maand",
      "description": "De aantallen zijn gegroepeerd per medewerker per maand"
    },
    "chart_bookings_present_day": {
      "title": "Totaal aantal boekingen + aanwezigheid per dag",
      "description": "De aantallen zijn gegroepeerd per medewerker per dag"
    },
    "chart_checkin_time_grow": {
      "title": "Check-in tijd",
      "description": "Op deze tijden wordt er het meeste ingecheckt"
    }
  },
  "user_rights": {
    "dashboard": "Dashboard",
    "presence": "Aanwezigheidslijst",
    "bookings": "Boekingen",
    "bookings_workplaces": "Werkplekken",
    "bookings_lunches": "Lunches",
    "bookings_meeting_rooms": "Vergaderruimtes",
    "bookings_parking_spots": "Parkeerplekken",
    "bookings_cancel": "Annuleren van boeking",
    "bookings_scan_in": "Inscannen",
    "bookings_accept_status": "Accepteren van boeking uitnodiging",
    "statistics": "Statistieken",
    "reports": "Rapportages",
    "teams": "Teams",
    "buildings": "Gebouwen",
    "departments": "Afdelingen",
    "employees": "Collega's",
    "settings": "Systeeminstellingen",
    "qrcodes": "Scan QR-codes",
    "companies": "Bedrijven",
    "jobtitles": "Functies",
    "information_messages": "Berichten",
    "company": "Bedrijf",
    "timeslots": "Tijdsloten",
    "teams_employees": "Rechten teams/medewerkers",
    "rooms": "Kamers",
    "floors": "Verdiepingen",
    "contact_persons": "Contactpersonen"
  },
  "ui": {
    "users": "Gebruikers",
    "read": "Lezen",
    "write": "Schrijven",
    "choose": "Kies een optie",
    "teams": "Teams",
    "company": "Bedrijf"
  }
}
